import React, { useEffect, useState, useRef } from "react";
import { Image, Layer, Shape, Stage, Text } from "react-konva";
import useImage from "use-image";
import { faStreetView } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DiagramImage = ({ onSelect, width, height, diagram }) => {
  const diagramRef = useRef();
  diagramRef?.current?.zIndex(0);
  const [diagramImg] = useImage(diagram?.src);

  return (
    <Image
      className="dnd-base-diagram"
      ref={diagramRef}
      image={diagramImg}
      onClick={onSelect}
      width={width}
      height={height}
    />
  );
};

const FloorDiagram = ({ plan, selectedRoom, onRoomSelect, nameMap }) => {
  const [baseDiagramImg, setBaseDiagramImg] = useState();

  let img = document.createElement("img");
  const stageRef = useRef();
  const layerRef = useRef();
  const roomRef = useRef();

  useEffect(() => {
    if (plan) {
      img.src = `data:image/png;base64, ${plan.imageBody}`;
      setBaseDiagramImg(img);
      layerRef?.current?.toDataURL();
    }
  }, [plan]);

  if (!baseDiagramImg?.naturalHeight) {
    return "";
  }

  const getSelectedRoomPosition = () => {
    const room = plan?.rooms?.find((r) => r.roomGrid === selectedRoom);
    return room && room.labelCoordinates
      ? {
          left: room.labelCoordinates[0].x + "px",
          top: room.labelCoordinates[0].y + "px",
        }
      : room?.polygons
      ? findCentroid(room.polygons)
      : {};
  };

  const findCentroid = (polygon) => {
    let xSum = 0,
      ySum = 0;

    // Loop through all points in the polygon array
    for (let i = 0; i < polygon.length; i++) {
      xSum += polygon[i].x; // Sum of x coordinates
      ySum += polygon[i].y; // Sum of y coordinates
    }

    // Calculate centroid by averaging the x and y coordinates
    let centroidX = xSum / polygon.length;
    let centroidY = ySum / polygon.length;

    return { left: centroidX, top: centroidY };
  };

  return (
    <>
      <Stage
        id={"floor-canvas"}
        width={baseDiagramImg?.naturalWidth}
        height={baseDiagramImg?.naturalHeight}
        ref={stageRef}
        onMouseDown={() => {
          roomRef?.current?.zIndex(1);
        }}
        onTouchStart={() => {
          roomRef?.current?.zIndex(1);
        }}
      >
        <Layer ref={layerRef}>
          <DiagramImage
            width={baseDiagramImg?.naturalWidth}
            height={baseDiagramImg?.naturalHeight}
            diagram={baseDiagramImg}
          />

          {/* room layers */}
          {plan &&
            plan.rooms?.map((room, roomIndex, { length }) => {
              let textSelector =
                (nameMap || {})[room.name] ||
                room.name ||
                room.description ||
                "";
              return (
                <>
                  {room?.labelCoordinates && (
                    <Text
                      key={room.roomId}
                      text={textSelector}
                      x={room.labelCoordinates[0].x}
                      y={room.labelCoordinates[0].y}
                      fontSize={11}
                      offsetX={0}
                      offsetY={0}
                      fontStyle="bold"
                      name={room.roomId}
                      width={67}
                      wrap={"word"}
                    />
                  )}
                  <Shape
                    key={roomIndex}
                    ref={roomRef}
                    hitStrokeWidth={1}
                    stroke={
                      room.roomGrid === selectedRoom ? "#A5004A" : "#000000" //"#00A54A"
                    }
                    fill={
                      room.roomGrid === selectedRoom
                        ? "rgba(227, 80, 77, 0.2)"
                        : "transparent" //"#9FF4C5"
                    }
                    opacity={0.5}
                    sceneFunc={(context, shape) => {
                      if (room.polygons) {
                        context.beginPath();
                        room.polygons.map((coordinates, i) => {
                          if (i === 0) {
                            context.moveTo(coordinates.x, coordinates.y);
                          } else {
                            context.lineTo(coordinates.x, coordinates.y);
                          }
                        });
                        context.closePath();
                        context.fillStrokeShape(shape);
                        roomRef?.current?.zIndex(1);
                      }
                    }}
                    name={room.roomId}
                    onClick={() => {
                      onRoomSelect(room);
                      room?.current?.zIndex(1);
                    }}
                  />
                </>
              );
            })}
        </Layer>
      </Stage>
      <FontAwesomeIcon icon={faStreetView} style={getSelectedRoomPosition()} />
    </>
  );
};

export default FloorDiagram;
